module.exports = __webpack_public_path__ + "static/media/Mobile_Data_PREPARATÓRIO_PARA_CERTIFICAÇÃO_ITIL_E_COBIT.4a615425.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/prep_cert/Mobile_Data_PREPARATÓRIO_PARA_CERTIFICAÇÃO_ITIL_E_COBIT.png
// module id = 89
// module chunks = 0